import { locales } from './locales.js'

export function buildPathTranslations(loadPaths) {
  return locales.reduce((translations, locale) => {
    translations[locale.code] = loadPaths(locale.file) || {}
    return translations
  }, {})
}

export function translatedPath(pathTranslations, code, key) {
  const translated = pathTranslations[code]?.[key]
  if (translated === false) return null
  return translated || pathTranslations.fr?.[key] || null
}

export function translateContentLinks(html, locale, pathTranslations) {
  if (!html || locale === 'fr') return html
  const patterns = Object.entries(pathTranslations.fr || {})
    .sort(([, a], [, b]) => b.length - a.length)
    .map(([key, frPath]) => ({
      key,
      regex: new RegExp(
        `https?://[^/]+${frPath.replace(
          /:[^/]+/g,
          '([^/?#"\'\\s<>]+)'
        )}(?=[/?#"'\\s<>]|$)`,
        'g'
      ),
    }))
  return patterns.reduce(
    (result, { key, regex }) =>
      result.replace(regex, (match, ...params) => {
        const translated = translatedPath(pathTranslations, locale, key)
        if (!translated) return match
        let index = 0
        return `/${locale}${translated.replace(
          /:([^/]+)/g,
          () => params[index++] || ''
        )}`
      }),
    html
  )
}

export function paramsOf(routePath) {
  return (String(routePath || '').match(/:[^/]+/g) || []).sort()
}
